import { Box, Button, Link, Modal } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect } from "react";
import CheckBox from "../../../../../Supporting files/CheckBox/CheckBox";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  value_update: Function;
  attrName: any;
}

const AddNewPolicyEmployer: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
}) => {
  const [policytype, setPolicyType] = React.useState("");
  const [policyid, setPolicyId] = React.useState("");
  const [insurer, setInsurer] = React.useState("");
  const [nol, setNol] = React.useState("");
  const [nolData, setNolData] = React.useState([{ label: "", value: "" }]);
  const [nod, setNod] = React.useState("");
  const [nodData, setNodData] = React.useState([{ label: "", value: "" }]);
  const [premium, setPremium] = React.useState("");
  const [pinCode, setPinCode] = React.useState("");
  const [clientid, setClientId] = React.useState("");
  const [dependent, setDependent] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [dependentType, setdependentType] = React.useState("");
  const [restoration, setRestoration] = React.useState(false);
  const [opdCover, setOpdCover] = React.useState(false);
  const [maternityCover, setMaternityCover] = React.useState(false);
  const [diabeticCover, setDiabeticCover] = React.useState(false);
  const [alternateTreatment, setAlternateTreatment] = React.useState(false);
  const [criticalIllness, setCriticalIllness] = React.useState(false);
  const [PaOwnerCover, setPaOwnerCover] = React.useState(false);
  const [zeroDepreciation, setZeroDepreciation] = React.useState(false);
  const [invoiceCover, setInvoiceCover] = React.useState(false);
  const [baggageLoss, setBaggageLoss] = React.useState(false);
  const [lossofPassport, setLossofPassport] = React.useState(false);
  const [delayinChecked, setDelayInChecked] = React.useState(false);
  const [personalLiability, setPersonalLiability] = React.useState(false);
  const [tripCancellation, setTripCancellation] = React.useState(false);
  const [tripDelay, setTripDelay] = React.useState(false);
  const [policyStatus, setPolicyStatus] = React.useState("");
  const [tripAbandonment, setTripAbandonment] = React.useState(false);
  const [businessClass, setBusinessClass] = React.useState(false);
  const [accidentalDeath, setAccidentalDeath] = React.useState(false);
  const [permanentPartial, setPermanentPartial] = React.useState(false);
  const [accidentalHospitalization, setAccidentalHospitalization] =
    React.useState(false);
  const [medicalExtension, setMedicalExtension] = React.useState(false);
  const [brokenBones, setBrokenBones] = React.useState(false);
  const [temporaryTotal, setTemporaryTotal] = React.useState(false);
  const [healthCheckup, setHealthCheckup] = React.useState(false);
  const [copay, setCopay] = React.useState(false);
  const [sumInsured, setSumInsured] = React.useState("");
  const [BranchLocation, setBranchLocation] = React.useState("");
  const [existingIllness, setExistingIllness] = React.useState(false);
  const [cashlessHospitals, setCashlessHospitals] = React.useState(false);
  const [dayCareTreatment, setDayCareTreatment] = React.useState(false);
  const [preHospitalization, setPreHospitalization] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [endDate, setEndDate] = React.useState<Date | null>(null);
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const policy_type_data = [
    { key: "Group Health Policy", value: "Group Health Policy" },
    { key: "Group Term Insurance", value: "Group Term Insurance" },
    { key: "Group Personal Accident", value: "Group Personal Accident" },
    { key: "Group Critical Illness", value: "Group Critical Illness" },
    { key: "Group Travel Insurance", value: "Group Travel Insurance" },
  ];
  const insurer_data = [
    { label: "Reliance", value: "Reliance" },
    { label: "Digit", value: "Digit" },
    { label: "Tata", value: "Tata" },
    { label: "Aditya Birla", value: "Aditya Birla" },
    { label: "Iffco", value: "Iffco" },
  ];
  const dependent_data = [
    { key: "Yes", value: "Yes" },
    { key: "No", value: "No" },
  ];
  const location_data = [
    { label: "India", value: "India" },
    { label: "Pakistan", value: "Pakistan" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
  ];
  const sumInsured_Data = [
    { label: "2L", value: "2L" },
    { label: "5L", value: "5L" },
    { label: "10L", value: "10L" },
    { label: "20L", value: "20L" },
    { label: "50L", value: "50L" },
  ];
  const policyStatus_Data = [
    { label: "Active", value: "Active" },
    { label: "Expired", value: "Expired" },
    { label: "Rejected", value: "Rejected" },
    { label: "Pending", value: "Pending" },
  ];
  const dependentTypeData = [
    { key: "Spouse Only", value: "Spouse Only" },
    { key: "Child Only", value: "Child Only" },
    { key: "Parents Only", value: "Parents Only" },
    { key: "Spouse, Child", value: "Spouse, Child" },
    { key: "Spouse, Child, Parents", value: "Spouse, Child, Parents" },
  ];
  useEffect(() => {
    let data = [];
    for (var i = 1000; i <= 2000; i++) {
      data.push({
        label: i.toString(),
        value: i.toString(),
      });
    }
    setNolData(data);
    setNodData(data);
  }, []);

  const changePageStatus = (status: Boolean) => {
    if (status == true) {
      if (pageStatus < 4) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  function updateMasterState(attrName: any, value: any) {
    attrName(value);
  }

  return (
    <Modal open={open_status} className="modalWrapper">
      <Box className="modalInner xl-width">
        <Grid container spacing={2} alignItems="center">
          <Grid xs={2} className="mb-4">
            {pageStatus == 1 || pageStatus == 4 ? null : (
              <Link
                className="back-button"
                onClick={() => {
                  changePageStatus(false);
                }}
              />
            )}
          </Grid>
          <Grid xs={8}>
            {pageStatus == 4 ? null : (
              <h2 className="popup-heading">Add New Policy</h2>
            )}
          </Grid>
          <Grid xs={2} className="text-right">
            <Link
              className="close-button"
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
        </Grid>
        {pageStatus == 1 ? (
          <Grid container spacing={2} className="mb-4">
            <Grid xs={4}>
              <RKTextField
                class_name="inputField"
                title="Policy Id"
                value={policyid}
                attrName={setPolicyId}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SelectDropdown
                class_name="inputField"
                warn_status={false}
                title="Policy Type"
                value={policytype}
                attrName={setPolicyType}
                value_update={updateMasterState}
                dropdown_data={policy_type_data}
              />
            </Grid>
            <Grid xs={4}>
              <SearchDropdown
                class_name="inputField"
                title="Insurer"
                value={insurer}
                attrName={setInsurer}
                value_update={updateMasterState}
                data={insurer_data}
                error_message="Please select Insurer"
                warn_status={false}
              />
            </Grid>

            <Grid xs={4}>
              <DatePicker
                class_name="inputField"
                title="Start Date"
                value={startDate}
                attrName={setStartDate}
                value_update={updateMasterState}
                error_message="Please enter term start date"
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <DatePicker
                class_name="inputField"
                title="End Date"
                value={endDate}
                attrName={setEndDate}
                value_update={updateMasterState}
                error_message="Please enter term end date"
                warn_status={false}
              />
            </Grid>
          </Grid>
        ) : pageStatus == 2 ? (
          <div>
            <Grid container spacing={2} className="mb-4">
              {policytype === "Group Health Policy" ? (
                <Grid xs={4}>
                  <SelectDropdown
                    class_name="inputField"
                    warn_status={false}
                    title="Dependents"
                    value={dependent}
                    attrName={setDependent}
                    value_update={updateMasterState}
                    dropdown_data={dependent_data}
                  />
                </Grid>
              ) : null}
              {dependent === "Yes" ? (
                <>
                  <Grid xs={4}>
                    <SelectDropdown
                      class_name="inputField"
                      warn_status={false}
                      title="Dependent Type"
                      value={dependentType}
                      attrName={setdependentType}
                      value_update={updateMasterState}
                      dropdown_data={dependentTypeData}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <SearchDropdown
                      class_name="inputField"
                      title="NOD"
                      value={nod}
                      attrName={setNod}
                      value_update={updateMasterState}
                      data={nodData}
                      error_message="Please select nod"
                      warn_status={false}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid xs={4}>
                <SearchDropdown
                  class_name="inputField"
                  title="NOL"
                  value={nol}
                  attrName={setNol}
                  value_update={updateMasterState}
                  data={nolData}
                  error_message="Please select nol"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <SearchDropdown
                  class_name="inputField"
                  title="Policy Status"
                  value={policyStatus}
                  attrName={setPolicyStatus}
                  value_update={updateMasterState}
                  data={policyStatus_Data}
                  error_message="Please select Policy Status"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <SearchDropdown
                  class_name="inputField"
                  title="Sum Insured"
                  value={sumInsured}
                  attrName={setSumInsured}
                  value_update={updateMasterState}
                  data={sumInsured_Data}
                  error_message="Please select Policy Status"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField"
                  title="Premium"
                  value={premium}
                  attrName={setPremium}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField"
                  title="Branch Location"
                  value={BranchLocation}
                  attrName={setBranchLocation}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
          </div>
        ) : pageStatus == 3 ? (
          <div>
            {policytype == "Group Health Policy" ? (
              <div>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <h5 className="checkbox_heading">Features</h5>
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Restoration"
                      name="restoration"
                      id="restoration"
                      value={restoration}
                      attrName={setRestoration}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="OPD Cover"
                      name="OPDCover"
                      id="OPDCover"
                      value={opdCover}
                      attrName={setOpdCover}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Maternity Cover"
                      name="MaternityCover"
                      id="MaternityCover"
                      value={maternityCover}
                      attrName={setMaternityCover}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Diabetic Cover"
                      name="DiabeticCover"
                      id="DiabeticCover"
                      value={diabeticCover}
                      attrName={setDiabeticCover}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Ayush/Alternate Treatment"
                      name="AlternateTreatment"
                      id="AlternateTreatment"
                      value={alternateTreatment}
                      attrName={setAlternateTreatment}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Critical Illness Add-on"
                      name="CriticalIllness"
                      id="CriticalIllness"
                      value={criticalIllness}
                      attrName={setCriticalIllness}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : policytype == "Group Term Insurance" ? (
              <div>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <h5 className="checkbox_heading">Features</h5>
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Critical Illness"
                      name="CriticalIllness"
                      id="CriticalIllness"
                      value={PaOwnerCover}
                      attrName={setPaOwnerCover}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Accidental Disability "
                      name="AccidentalDisability"
                      id="AccidentalDisability"
                      value={zeroDepreciation}
                      attrName={setZeroDepreciation}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Accidental Death"
                      name="AccidentalDeath"
                      id="AccidentalDeath"
                      value={invoiceCover}
                      attrName={setInvoiceCover}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : policytype == "Group Travel Insurance" ? (
              <div>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <h5 className="checkbox_heading">Features</h5>
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Baggage Loss"
                      name="BaggageLoss"
                      id="BaggageLoss"
                      value={baggageLoss}
                      attrName={setBaggageLoss}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Loss of Passport "
                      name="LossofPassport"
                      id="LossofPassport"
                      value={lossofPassport}
                      attrName={setLossofPassport}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Delay in Checked-in Baggage"
                      name="DelayinChecked"
                      id="DelayinChecked"
                      value={delayinChecked}
                      attrName={setDelayInChecked}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Personal Liability"
                      name="PersonalLiability"
                      id="PersonalLiability"
                      value={personalLiability}
                      attrName={setPersonalLiability}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Trip Cancellation"
                      name="TripCancellation"
                      id="TripCancellation"
                      value={tripCancellation}
                      attrName={setTripCancellation}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Trip Delay"
                      name="TripDelay"
                      id="TripDelay"
                      value={tripDelay}
                      attrName={setTripDelay}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Trip Abandonment"
                      name="TripAbandonment"
                      id="TripAbandonment"
                      value={tripAbandonment}
                      attrName={setTripAbandonment}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Upgradation to Business Class"
                      name="BusinessClass"
                      id="BusinessClass"
                      value={businessClass}
                      attrName={setBusinessClass}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : policytype == "Group Personal Accident" ? (
              <div>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <h5 className="checkbox_heading">Features</h5>
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Accidental Death"
                      name="AccidentalDeath"
                      id="AccidentalDeath"
                      value={accidentalDeath}
                      attrName={setAccidentalDeath}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Permanent Partial Disability(PPD)"
                      name="PermanentPartial"
                      id="PermanentPartial"
                      value={permanentPartial}
                      attrName={setPermanentPartial}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Accidental Hospitalization "
                      name="AccidentalHospitalization"
                      id="AccidentalHospitalization"
                      value={accidentalHospitalization}
                      attrName={setAccidentalHospitalization}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Medical Extension"
                      name="MedicalExtension"
                      id="MedicalExtension"
                      value={medicalExtension}
                      attrName={setMedicalExtension}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Broken Bones Coverage"
                      name="BrokenBones"
                      id="BrokenBones"
                      value={brokenBones}
                      attrName={setBrokenBones}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Temporary Total Disablement (TTD)"
                      name="TemporaryTotal"
                      id="TemporaryTotal"
                      value={temporaryTotal}
                      attrName={setTemporaryTotal}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : policytype == "Group Critical Illness" ? (
              <div>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <h5 className="checkbox_heading">Features</h5>
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Free health checkup"
                      name="healthcheckup"
                      id="healthcheckup"
                      value={healthCheckup}
                      attrName={setHealthCheckup}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Co-pay"
                      name="Co-pay"
                      id="Co-pay"
                      value={copay}
                      attrName={setCopay}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Existing Illness cover"
                      name="ExistingIllness"
                      id="ExistingIllness"
                      value={existingIllness}
                      attrName={setExistingIllness}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Cashless hospitals"
                      name="Cashlesshospitals"
                      id="Cashlesshospitals"
                      value={cashlessHospitals}
                      attrName={setCashlessHospitals}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Pre-hospitalization coverage"
                      name="Prehospitalization"
                      id="Prehospitalization"
                      value={preHospitalization}
                      attrName={setPreHospitalization}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                  <Grid xs={4}>
                    <CheckBox
                      title="Day care treatment"
                      name="Daycaretreatment"
                      id="Daycaretreatment"
                      value={dayCareTreatment}
                      attrName={setDayCareTreatment}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : null}
          </div>
        ) : pageStatus == 4 ? (
          <Grid container spacing={2}>
            <Grid xs={12}>
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <p className="quote_success">
                New Policy has been added successfully!
              </p>
            </Grid>
          </Grid>
        ) : null}
        <Grid container spacing={2}>
          {pageStatus == 4 ? null : (
            <Grid
              xs={12}
              style={{ textAlign: "center", position: "relative" }}
              className="ctaBtn"
            >
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  changePageStatus(true);
                }}
              >
                {pageStatus == 3 ? "Submit" : "Continue"}
              </Button>
              {pageStatus == 4 ? null : (
                <h5 className="steps">
                  {pageStatus}
                  <span>/3</span>
                </h5>
              )}
            </Grid>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddNewPolicyEmployer;
